import { FC } from 'react';
import { useLocation } from 'react-router';
import { getUrlParams } from 'utils/urlParams';
import { FACEBOOK_REDIRECT_URL } from '../constants';
import { convertRedirectPath } from '../utils';
import { FacebookLoginContext } from './FacebookLoginContext';

export const FacebookLoginContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const reconstructedPath = convertRedirectPath(FACEBOOK_REDIRECT_URL);

  const { search } = useLocation();
  const { code } = getUrlParams(search);

  const value = {
    loginCode: code,
    facebookLoginUrl: reconstructedPath,
  };

  return <FacebookLoginContext.Provider value={value}>{children}</FacebookLoginContext.Provider>;
};
